import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectBrokerConsultantBannerAvailable } from '../../selectors/brokerConsultantBanner';
import { isDiscountMortgageBannerEnabled } from '../../selectors/discountMortgage';
import { DiscountMortgageBannerContainer } from '../DiscountMortgageBannerContainer';
import { BrokerSelfRequestFormBannerContainer } from '../BrokerSelfRequestFormBannerContainer';

export const BannerContainer = () => {
  const isDiscountMortgageBannerAvailable = useSelector(isDiscountMortgageBannerEnabled);
  const isBrokerConsultantBannerAvailable = useSelector(selectBrokerConsultantBannerAvailable);

  if (isDiscountMortgageBannerAvailable) {
    return <DiscountMortgageBannerContainer />;
  }

  if (isBrokerConsultantBannerAvailable) {
    return <BrokerSelfRequestFormBannerContainer />;
  }

  return null;
};
